export const RAW_BANK_TRANSACTIONS_BASE_QUERY_KEY = 'raw-bank-transactions';

export const rawBankTransactionsApiQueryKeys = {
  all: () => [RAW_BANK_TRANSACTIONS_BASE_QUERY_KEY] as const,
  raw: () => [RAW_BANK_TRANSACTIONS_BASE_QUERY_KEY, 'raw'] as const,
  byId: (id: string) => [RAW_BANK_TRANSACTIONS_BASE_QUERY_KEY, id] as const,
  supportedBanks: () =>
    [RAW_BANK_TRANSACTIONS_BASE_QUERY_KEY, 'supported-banks'] as const,
  imports: () => [RAW_BANK_TRANSACTIONS_BASE_QUERY_KEY, 'imports'] as const,
  importById: (importId: string) =>
    [RAW_BANK_TRANSACTIONS_BASE_QUERY_KEY, 'imports', importId] as const,
  importTransactions: (importId: string) =>
    [
      RAW_BANK_TRANSACTIONS_BASE_QUERY_KEY,
      'imports',
      importId,
      'transactions',
    ] as const,
};
